import { ModuleDefinition } from "src/typings/flexFramework/FlexComponent";
import { BlossomComponentsFactory } from "components/flexFramework/domain/BlossomComponentsFactory";
import { BlossomComponent } from "components/flexFramework/domain/BlossomComponent";
import { moduleDefinitionsMap } from "components/flexFramework/ModuleDefinitions/moduleDefinitionMap";

export class BlossomComponentFromTemplate extends BlossomComponent {
  public readonly moduleDefinition: ModuleDefinition;

  public constructor(moduleDefinition: ModuleDefinition) {
    super(moduleDefinition, moduleDefinitionsMap);
    this.moduleDefinition = moduleDefinition;
    this.type = moduleDefinition.fmType;
  }

  public shouldRender = () => true;

  // Since regions don't have consistent names, we need to handle them properly.
  // Otherwise, just give the component name
  public getName = () =>
    this.moduleDefinition.fmType === "REGION" ? "region" : this.moduleDefinition.name;
  public getId = () => undefined;
  public getView = () => this.moduleDefinition.view;
  public getBlossomComponents = () => {
    return [
      ...BlossomComponentsFactory.get({ moduleDefinitions: this.moduleDefinition.modules }),
      ...BlossomComponentsFactory.get({ moduleDefinitions: this.moduleDefinition.groups })
    ];
  };

  public getProps = () => {
    return {
      moduleDefinition: this.moduleDefinition
    };
  };

  public getModel = <T>() => {
    return (this.moduleDefinition as any) as T;
  };
}
